"use client";
import { api } from "@/lib/api";
import IMask from "imask";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";

const nacionality = {
  pt: [
    { value: "afghan", label: "Afegã" },
    { value: "albanian", label: "Albanesa" },
    { value: "algerian", label: "Argelina" },
    { value: "andorran", label: "Andorrana" },
    { value: "angolan", label: "Angolana" },
    { value: "argentine", label: "Argentina" },
    { value: "armenian", label: "Armênia" },
    { value: "australian", label: "Australiana" },
    { value: "austrian", label: "Austriaca" },
    { value: "bangladeshi", label: "Bangladense" },
    { value: "belgian", label: "Belga" },
    { value: "bolivian", label: "Boliviana" },
    { value: "bosnian", label: "Bósnia" },
    { value: "brazilian", label: "Brasileira" },
    { value: "british", label: "Britânica" },
    { value: "bulgarian", label: "Búlgara" },
    { value: "cambodian", label: "Cambojana" },
    { value: "canadian", label: "Canadense" },
    { value: "chilean", label: "Chilena" },
    { value: "chinese", label: "Chinesa" },
    { value: "colombian", label: "Colombiana" },
    { value: "costa-rican", label: "Costarriquenha" },
    { value: "croatian", label: "Croata" },
    { value: "cuban", label: "Cubana" },
    { value: "czech", label: "Tcheca" },
    { value: "danish", label: "Dinamarquesa" },
    { value: "dominican", label: "Dominicana" },
    { value: "dutch", label: "Holandesa" },
    { value: "egyptian", label: "Egípcia" },
    { value: "salvadoran", label: "Salvadorenha" },
    { value: "estonian", label: "Estoniana" },
    { value: "ethiopian", label: "Etíope" },
    { value: "finnish", label: "Finlandesa" },
    { value: "french", label: "Francesa" },
    { value: "german", label: "Alemã" },
    { value: "greek", label: "Grega" },
    { value: "guatemalan", label: "Guatemalteca" },
    { value: "haitian", label: "Haitiana" },
    { value: "honduran", label: "Hondurenha" },
    { value: "hungarian", label: "Húngara" },
    { value: "icelandic", label: "Islandesa" },
    { value: "indian", label: "Indiana" },
    { value: "indonesian", label: "Indonésia" },
    { value: "iranian", label: "Iraniana" },
    { value: "iraqi", label: "Iraquiana" },
    { value: "irish", label: "Irlandesa" },
    { value: "israeli", label: "Israelense" },
    { value: "italian", label: "Italiana" },
    { value: "japanese", label: "Japonesa" },
    { value: "jordanian", label: "Jordana" },
    { value: "kenyan", label: "Queniana" },
    { value: "korean", label: "Coreana" },
    { value: "kuwaiti", label: "Kuwaitiana" },
    { value: "latvian", label: "Letã" },
    { value: "lebanese", label: "Libanesa" },
    { value: "libyan", label: "Líbia" },
    { value: "lithuanian", label: "Lituana" },
    { value: "malaysian", label: "Malaia" },
    { value: "mexican", label: "Mexicana" },
    { value: "moroccan", label: "Marroquina" },
    { value: "nepalese", label: "Nepalesa" },
    { value: "new zealander", label: "Neozelandesa" },
    { value: "nigerian", label: "Nigeriana" },
    { value: "norwegian", label: "Norueguesa" },
    { value: "pakistani", label: "Paquistanesa" },
    { value: "panamanian", label: "Panamenha" },
    { value: "paraguayan", label: "Paraguaia" },
    { value: "peruvian", label: "Peruana" },
    { value: "philippine", label: "Filipina" },
    { value: "polish", label: "Polonesa" },
    { value: "portuguese", label: "Portuguesa" },
    { value: "puerto rican", label: "Porto-Riquenha" },
    { value: "qatari", label: "Catariana" },
    { value: "romanian", label: "Romena" },
    { value: "russian", label: "Russa" },
    { value: "saudi", label: "Saudita" },
    { value: "scottish", label: "Escocesa" },
    { value: "senegalese", label: "Senegalesa" },
    { value: "serbian", label: "Sérvia" },
    { value: "singaporean", label: "Singapurense" },
    { value: "slovak", label: "Eslovaca" },
    { value: "slovenian", label: "Eslovena" },
    { value: "south african", label: "Sul-africana" },
    { value: "spanish", label: "Espanhola" },
    { value: "swedish", label: "Sueca" },
    { value: "swiss", label: "Suíça" },
    { value: "syrian", label: "Síria" },
    { value: "taiwanese", label: "Taiwanesa" },
    { value: "thai", label: "Tailandesa" },
    { value: "tunisian", label: "Tunisiana" },
    { value: "turkish", label: "Turca" },
    { value: "ukrainian", label: "Ucraniana" },
    { value: "uruguayan", label: "Uruguaia" },
    { value: "venezuelan", label: "Venezuelana" },
    { value: "vietnamese", label: "Vietnamita" },
    { value: "welsh", label: "Galesa" },
    { value: "yemeni", label: "Iemenita" },
    { value: "zimbabwean", label: "Zimbabuense" },
  ],
  en: [
    { value: "afghan", label: "Afghan" },
    { value: "albanian", label: "Albanian" },
    { value: "algerian", label: "Algerian" },
    { value: "andorran", label: "Andorran" },
    { value: "angolan", label: "Angolan" },
    { value: "argentine", label: "Argentine" },
    { value: "armenian", label: "Armenian" },
    { value: "australian", label: "Australian" },
    { value: "austrian", label: "Austrian" },
    { value: "bangladeshi", label: "Bangladeshi" },
    { value: "belgian", label: "Belgian" },
    { value: "bolivian", label: "Bolivian" },
    { value: "bosnian", label: "Bosnian" },
    { value: "brazilian", label: "Brazilian" },
    { value: "british", label: "British" },
    { value: "bulgarian", label: "Bulgarian" },
    { value: "cambodian", label: "Cambodian" },
    { value: "canadian", label: "Canadian" },
    { value: "chilean", label: "Chilean" },
    { value: "chinese", label: "Chinese" },
    { value: "colombian", label: "Colombian" },
    { value: "costa-rican", label: "Costa Rican" },
    { value: "croatian", label: "Croatian" },
    { value: "cuban", label: "Cuban" },
    { value: "czech", label: "Czech" },
    { value: "danish", label: "Danish" },
    { value: "dominican", label: "Dominican" },
    { value: "dutch", label: "Dutch" },
    { value: "egyptian", label: "Egyptian" },
    { value: "salvadoran", label: "Salvadoran" },
    { value: "estonian", label: "Estonian" },
    { value: "ethiopian", label: "Ethiopian" },
    { value: "finnish", label: "Finnish" },
    { value: "french", label: "French" },
    { value: "german", label: "German" },
    { value: "greek", label: "Greek" },
    { value: "guatemalan", label: "Guatemalan" },
    { value: "haitian", label: "Haitian" },
    { value: "honduran", label: "Honduran" },
    { value: "hungarian", label: "Hungarian" },
    { value: "icelandic", label: "Icelandic" },
    { value: "indian", label: "Indian" },
    { value: "indonesian", label: "Indonesian" },
    { value: "iranian", label: "Iranian" },
    { value: "iraqi", label: "Iraqi" },
    { value: "irish", label: "Irish" },
    { value: "israeli", label: "Israeli" },
    { value: "italian", label: "Italian" },
    { value: "japanese", label: "Japanese" },
    { value: "jordanian", label: "Jordanian" },
    { value: "kenyan", label: "Kenyan" },
    { value: "korean", label: "Korean" },
    { value: "kuwaiti", label: "Kuwaiti" },
    { value: "latvian", label: "Latvian" },
    { value: "lebanese", label: "Lebanese" },
    { value: "libyan", label: "Libyan" },
    { value: "lithuanian", label: "Lithuanian" },
    { value: "malaysian", label: "Malaysian" },
    { value: "mexican", label: "Mexican" },
    { value: "moroccan", label: "Moroccan" },
    { value: "nepalese", label: "Nepalese" },
    { value: "new zealander", label: "New Zealander" },
    { value: "nigerian", label: "Nigerian" },
    { value: "norwegian", label: "Norwegian" },
    { value: "pakistani", label: "Pakistani" },
    { value: "panamanian", label: "Panamanian" },
    { value: "paraguayan", label: "Paraguayan" },
    { value: "peruvian", label: "Peruvian" },
    { value: "philippine", label: "Philippine" },
    { value: "polish", label: "Polish" },
    { value: "portuguese", label: "Portuguese" },
    { value: "puerto rican", label: "Puerto Rican" },
    { value: "qatari", label: "Qatari" },
    { value: "romanian", label: "Romanian" },
    { value: "russian", label: "Russian" },
    { value: "saudi", label: "Saudi" },
    { value: "scottish", label: "Scottish" },
    { value: "senegalese", label: "Senegalese" },
    { value: "serbian", label: "Serbian" },
    { value: "singaporean", label: "Singaporean" },
    { value: "slovak", label: "Slovak" },
    { value: "slovenian", label: "Slovenian" },
    { value: "south african", label: "South African" },
    { value: "spanish", label: "Spanish" },
    { value: "swedish", label: "Swedish" },
    { value: "swiss", label: "Swiss" },
    { value: "syrian", label: "Syrian" },
    { value: "taiwanese", label: "Taiwanese" },
    { value: "thai", label: "Thai" },
    { value: "tunisian", label: "Tunisian" },
    { value: "turkish", label: "Turkish" },
    { value: "ukrainian", label: "Ukrainian" },
    { value: "uruguayan", label: "Uruguayan" },
    { value: "venezuelan", label: "Venezuelan" },
    { value: "vietnamese", label: "Vietnamese" },
    { value: "welsh", label: "Welsh" },
    { value: "yemeni", label: "Yemeni" },
    { value: "zimbabwean", label: "Zimbabwean" },
  ],
  es: [
    { value: "afghan", label: "Afgana" },
    { value: "albanian", label: "Albanesa" },
    { value: "algerian", label: "Argelina" },
    { value: "andorran", label: "Andorrana" },
    { value: "angolan", label: "Angoleña" },
    { value: "argentine", label: "Argentina" },
    { value: "armenian", label: "Armenia" },
    { value: "australian", label: "Australiana" },
    { value: "austrian", label: "Austriaca" },
    { value: "bangladeshi", label: "Bangladesí" },
    { value: "belgian", label: "Belga" },
    { value: "bolivian", label: "Boliviana" },
    { value: "bosnian", label: "Bosnia" },
    { value: "brazilian", label: "Brasileña" },
    { value: "british", label: "Británica" },
    { value: "bulgarian", label: "Búlgara" },
    { value: "cambodian", label: "Camboyana" },
    { value: "canadian", label: "Canadiense" },
    { value: "chilean", label: "Chilena" },
    { value: "chinese", label: "China" },
    { value: "colombian", label: "Colombiana" },
    { value: "costa-rican", label: "Costarricense" },
    { value: "croatian", label: "Croata" },
    { value: "cuban", label: "Cubana" },
    { value: "czech", label: "Checa" },
    { value: "danish", label: "Danesa" },
    { value: "dominican", label: "Dominicana" },
    { value: "dutch", label: "Neerlandesa" },
    { value: "egyptian", label: "Egipcia" },
    { value: "salvadoran", label: "Salvadoreña" },
    { value: "estonian", label: "Estonia" },
    { value: "ethiopian", label: "Etíope" },
    { value: "finnish", label: "Finlandesa" },
    { value: "french", label: "Francesa" },
    { value: "german", label: "Alemana" },
    { value: "greek", label: "Griega" },
    { value: "guatemalan", label: "Guatemalteca" },
    { value: "haitian", label: "Haitiana" },
    { value: "honduran", label: "Hondureña" },
    { value: "hungarian", label: "Húngara" },
    { value: "icelandic", label: "Islandesa" },
    { value: "indian", label: "India" },
    { value: "indonesian", label: "Indonesia" },
    { value: "iranian", label: "Iraní" },
    { value: "iraqi", label: "Iraquí" },
    { value: "irish", label: "Irlandesa" },
    { value: "israeli", label: "Israelí" },
    { value: "italian", label: "Italiana" },
    { value: "japanese", label: "Japonesa" },
    { value: "jordanian", label: "Jordana" },
    { value: "kenyan", label: "Keniata" },
    { value: "korean", label: "Coreana" },
    { value: "kuwaiti", label: "Kuwaití" },
    { value: "latvian", label: "Letona" },
    { value: "lebanese", label: "Libanesa" },
    { value: "libyan", label: "Libia" },
    { value: "lithuanian", label: "Lituana" },
    { value: "malaysian", label: "Malaya" },
    { value: "mexican", label: "Mexicana" },
    { value: "moroccan", label: "Marroquí" },
    { value: "nepalese", label: "Nepalesa" },
    { value: "new zealander", label: "Neozelandesa" },
    { value: "nigerian", label: "Nigeriana" },
    { value: "norwegian", label: "Noruega" },
    { value: "pakistani", label: "Paquistaní" },
    { value: "panamanian", label: "Panameña" },
    { value: "paraguayan", label: "Paraguaya" },
    { value: "peruvian", label: "Peruana" },
    { value: "philippine", label: "Filipina" },
    { value: "polish", label: "Polaca" },
    { value: "portuguese", label: "Portuguesa" },
    { value: "puerto rican", label: "Puertorriqueña" },
    { value: "qatari", label: "Catarí" },
    { value: "romanian", label: "Rumana" },
    { value: "russian", label: "Rusa" },
    { value: "saudi", label: "Saudí" },
    { value: "scottish", label: "Escocesa" },
    { value: "senegalese", label: "Senegalesa" },
    { value: "serbian", label: "Serbia" },
    { value: "singaporean", label: "Singapurense" },
    { value: "slovak", label: "Eslovaca" },
    { value: "slovenian", label: "Eslovena" },
    { value: "south african", label: "Sudafricana" },
    { value: "spanish", label: "Española" },
    { value: "swedish", label: "Sueca" },
    { value: "swiss", label: "Suiza" },
    { value: "syrian", label: "Siria" },
    { value: "taiwanese", label: "Taiwanesa" },
    { value: "thai", label: "Tailandesa" },
    { value: "tunisian", label: "Tunecina" },
    { value: "turkish", label: "Turca" },
    { value: "ukrainian", label: "Ucraniana" },
    { value: "uruguayan", label: "Uruguaya" },
    { value: "venezuelan", label: "Venezolana" },
    { value: "vietnamese", label: "Vietnamita" },
    { value: "welsh", label: "Galesa" },
    { value: "yemeni", label: "Yemení" },
    { value: "zimbabwean", label: "Zimbabuense" },
  ],
};

const maritalState = [
  {
    value: "Single",
    label: {
      pt: "Solteiro(a)",
      en: "Single",
      es: "Soltero(a)",
    },
  },
  {
    value: "Married",
    label: {
      pt: "Casado(a)",
      en: "Married",
      es: "Casado(a)",
    },
  },
  {
    value: "Divorced",
    label: {
      pt: "Divorciado(a)",
      en: "Divorced",
      es: "Divorciado(a)",
    },
  },
  {
    value: "Widowed",
    label: {
      pt: "Viúvo(a)",
      en: "Widowed",
      es: "Viudo(a)",
    },
  },
  {
    value: "Separated",
    label: {
      pt: "Separado(a)",
      en: "Separated",
      es: "Separado(a)",
    },
  },
  {
    value: "Domestic Partnership",
    label: {
      pt: "União estável",
      en: "Domestic Partnership",
      es: "Pareja de hecho",
    },
  },
  {
    value: "Civil Union",
    label: {
      pt: "União civil",
      en: "Civil Union",
      es: "Unión civil",
    },
  },
  {
    value: "Engaged",
    label: {
      pt: "Noivo(a)",
      en: "Engaged",
      es: "Comprometido(a)",
    },
  },
  {
    value: "Prefer not to say",
    label: {
      pt: "Prefiro não dizer",
      en: "Prefer not to say",
      es: "Prefiero no decirlo",
    },
  },
];

const educationLevel = [
  {
    value: "No formal education",
    label: {
      pt: "Educação formal ausente",
      en: "No formal education",
      es: "Sin educación formal",
    },
  },
  {
    value: "Primary education",
    label: {
      pt: "Ensino fundamental",
      en: "Primary education",
      es: "Educación primaria",
    },
  },
  {
    value: "Secondary education (High school)",
    label: {
      pt: "Ensino médio",
      en: "Secondary education (High school)",
      es: "Educación secundaria (Escuela secundaria)",
    },
  },
  {
    value: "Vocational qualification",
    label: {
      pt: "Qualificação profissional",
      en: "Vocational qualification",
      es: "Formación profesional",
    },
  },
  {
    value: "Associate degree",
    label: {
      pt: "Tecnólogo",
      en: "Associate degree",
      es: "Técnico superior",
    },
  },
  {
    value: "Bachelor's degree",
    label: {
      pt: "Bacharelado",
      en: "Bachelor's degree",
      es: "Licenciatura",
    },
  },
  {
    value: "Master's degree",
    label: {
      pt: "Mestrado",
      en: "Master's degree",
      es: "Maestría",
    },
  },
  {
    value: "Doctorate (Ph.D.)",
    label: {
      pt: "Doutorado",
      en: "Doctorate (Ph.D.)",
      es: "Doctorado",
    },
  },
  {
    value: "Professional degree (e.g., JD, MD)",
    label: {
      pt: "Título profissional (ex: JD, MD)",
      en: "Professional degree (e.g., JD, MD)",
      es: "Título profesional (p. ej., JD, MD)",
    },
  },
  {
    value: "Prefer not to say",
    label: {
      pt: "Prefiro não dizer",
      en: "Prefer not to say",
      es: "Prefiero no decirlo",
    },
  },
];

const countries = {
  pt: [
    "Afeganistão",
    "Albânia",
    "Alemanha",
    "Andorra",
    "Angola",
    "Antígua e Barbuda",
    "Arábia Saudita",
    "Argélia",
    "Argentina",
    "Armênia",
    "Austrália",
    "Áustria",
    "Azerbaijão",
    "Bahamas",
    "Bangladesh",
    "Barbados",
    "Bahrein",
    "Bélgica",
    "Belize",
    "Benim",
    "Bielorrússia",
    "Mianmar",
    "Bolívia",
    "Bósnia e Herzegovina",
    "Botsuana",
    "Brasil",
    "Brunei",
    "Bulgária",
    "Burquina Faso",
    "Burundi",
    "Butão",
    "Cabo Verde",
    "Camboja",
    "Camarões",
    "Canadá",
    "Catar",
    "Chade",
    "Chile",
    "China",
    "Chipre",
    "Colômbia",
    "Comores",
    "Coreia do Norte",
    "Coreia do Sul",
    "Costa do Marfim",
    "Costa Rica",
    "Croácia",
    "Cuba",
    "Dinamarca",
    "Dominica",
    "Equador",
    "Egito",
    "El Salvador",
    "Emirados Árabes Unidos",
    "Eritreia",
    "Eslováquia",
    "Eslovênia",
    "Espanha",
    "Estados Unidos",
    "Estônia",
    "Etiópia",
    "Filipinas",
    "Finlândia",
    "Fiji",
    "França",
    "Gabão",
    "Gâmbia",
    "Geórgia",
    "Gana",
    "Granada",
    "Grécia",
    "Guatemala",
    "Guiné",
    "Guiné-Bissau",
    "Guiné Equatorial",
    "Guiana",
    "Haiti",
    "Honduras",
    "Hungria",
    "Índia",
    "Indonésia",
    "Iraque",
    "Irã",
    "Irlanda",
    "Islândia",
    "Ilhas Marshall",
    "Ilhas Salomão",
    "Israel",
    "Itália",
    "Jamaica",
    "Japão",
    "Jordânia",
    "Cazaquistão",
    "Quênia",
    "Quirguistão",
    "Quiribati",
    "Kuwait",
    "Laos",
    "Lesoto",
    "Letônia",
    "Líbano",
    "Libéria",
    "Líbia",
    "Liechtenstein",
    "Lituânia",
    "Luxemburgo",
    "Macedônia do Norte",
    "Madagáscar",
    "Malásia",
    "Malawi",
    "Maldivas",
    "Mali",
    "Malta",
    "Marrocos",
    "Maurício",
    "Mauritânia",
    "México",
    "Micronésia",
    "Moldávia",
    "Mônaco",
    "Mongólia",
    "Montenegro",
    "Moçambique",
    "Namíbia",
    "Nauru",
    "Nepal",
    "Nicarágua",
    "Níger",
    "Nigéria",
    "Noruega",
    "Nova Zelândia",
    "Omã",
    "Países Baixos",
    "Paquistão",
    "Palau",
    "Panamá",
    "Papua-Nova Guiné",
    "Paraguai",
    "Peru",
    "Polônia",
    "Portugal",
    "Reino Unido",
    "República Centro-Africana",
    "República Tcheca",
    "República do Congo",
    "República Democrática do Congo",
    "República Dominicana",
    "Ruanda",
    "Romênia",
    "Rússia",
    "Samoa",
    "São Cristóvão e Névis",
    "San Marino",
    "São Vicente e Granadinas",
    "Santa Lúcia",
    "São Tomé e Príncipe",
    "Senegal",
    "Sérvia",
    "Seicheles",
    "Serra Leoa",
    "Singapura",
    "Síria",
    "Somália",
    "Sri Lanka",
    "África do Sul",
    "Sudão",
    "Sudão do Sul",
    "Suécia",
    "Suíça",
    "Suriname",
    "Tailândia",
    "Tanzânia",
    "Tajiquistão",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trindade e Tobago",
    "Tunísia",
    "Turcomenistão",
    "Turquia",
    "Ucrânia",
    "Uganda",
    "Uruguai",
    "Uzbequistão",
    "Vanuatu",
    "Vaticano",
    "Venezuela",
    "Vietnã",
    "Iémen",
    "Djibuti",
    "Zâmbia",
    "Zimbábue",
  ],
  en: [
    "Afghanistan",
    "Albania",
    "Germany",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Saudi Arabia",
    "Algeria",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bangladesh",
    "Barbados",
    "Bahrain",
    "Belgium",
    "Belize",
    "Benin",
    "Belarus",
    "Myanmar",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Bhutan",
    "Cape Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Qatar",
    "Chad",
    "Chile",
    "China",
    "Cyprus",
    "Colombia",
    "Comoros",
    "North Korea",
    "South Korea",
    "Ivory Coast",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Denmark",
    "Dominica",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "United Arab Emirates",
    "Eritrea",
    "Slovakia",
    "Slovenia",
    "Spain",
    "United States",
    "Estonia",
    "Ethiopia",
    "Philippines",
    "Finland",
    "Fiji",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Ghana",
    "Grenada",
    "Greece",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Equatorial Guinea",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "India",
    "Indonesia",
    "Iraq",
    "Iran",
    "Ireland",
    "Iceland",
    "Marshall Islands",
    "Solomon Islands",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kyrgyzstan",
    "Kiribati",
    "Kuwait",
    "Laos",
    "Lesotho",
    "Latvia",
    "Lebanon",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "North Macedonia",
    "Madagascar",
    "Malaysia",
    "Malawi",
    "Maldives",
    "Mali",
    "Malta",
    "Morocco",
    "Mauritius",
    "Mauritania",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Mozambique",
    "Namibia",
    "Nauru",
    "Nepal",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "New Zealand",
    "Oman",
    "Netherlands",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Poland",
    "Portugal",
    "United Kingdom",
    "Central African Republic",
    "Czech Republic",
    "Republic of the Congo",
    "Democratic Republic of the Congo",
    "Dominican Republic",
    "Rwanda",
    "Romania",
    "Russia",
    "Samoa",
    "Saint Kitts and Nevis",
    "San Marino",
    "Saint Vincent and the Grenadines",
    "Saint Lucia",
    "São Tomé and Príncipe",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Syria",
    "Somalia",
    "Sri Lanka",
    "South Africa",
    "Sudan",
    "South Sudan",
    "Sweden",
    "Switzerland",
    "Suriname",
    "Thailand",
    "Tanzania",
    "Tajikistan",
    "East Timor",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkmenistan",
    "Turkey",
    "Ukraine",
    "Uganda",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Djibouti",
    "Zambia",
    "Zimbabwe",
  ],
  es: [
    "Afganistán",
    "Albania",
    "Alemania",
    "Andorra",
    "Angola",
    "Antigua y Barbuda",
    "Arabia Saudita",
    "Argelia",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaiyán",
    "Bahamas",
    "Bangladés",
    "Barbados",
    "Baréin",
    "Bélgica",
    "Belice",
    "Benín",
    "Bielorrusia",
    "Birmania",
    "Bolivia",
    "Bosnia y Herzegovina",
    "Botsuana",
    "Brasil",
    "Brunéi",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Bután",
    "Cabo Verde",
    "Camboya",
    "Camerún",
    "Canadá",
    "Catar",
    "Chad",
    "Chile",
    "China",
    "Chipre",
    "Colombia",
    "Comoras",
    "Corea del Norte",
    "Corea del Sur",
    "Costa de Marfil",
    "Costa Rica",
    "Croacia",
    "Cuba",
    "Dinamarca",
    "Dominica",
    "Ecuador",
    "Egipto",
    "El Salvador",
    "Emiratos Árabes Unidos",
    "Eritrea",
    "Eslovaquia",
    "Eslovenia",
    "España",
    "Estados Unidos",
    "Estonia",
    "Etiopía",
    "Filipinas",
    "Finlandia",
    "Fiyi",
    "Francia",
    "Gabón",
    "Gambia",
    "Georgia",
    "Ghana",
    "Granada",
    "Grecia",
    "Guatemala",
    "Guinea",
    "Guinea-Bisáu",
    "Guinea Ecuatorial",
    "Guyana",
    "Haití",
    "Honduras",
    "Hungría",
    "India",
    "Indonesia",
    "Irak",
    "Irán",
    "Irlanda",
    "Islandia",
    "Islas Marshall",
    "Islas Salomón",
    "Israel",
    "Italia",
    "Jamaica",
    "Japón",
    "Jordania",
    "Kazajistán",
    "Kenia",
    "Kirguistán",
    "Kiribati",
    "Kuwait",
    "Laos",
    "Lesoto",
    "Letonia",
    "Líbano",
    "Liberia",
    "Libia",
    "Liechtenstein",
    "Lituania",
    "Luxemburgo",
    "Macedonia del Norte",
    "Madagascar",
    "Malasia",
    "Malaui",
    "Maldivas",
    "Malí",
    "Malta",
    "Marruecos",
    "Mauricio",
    "Mauritania",
    "México",
    "Micronesia",
    "Moldavia",
    "Mónaco",
    "Mongolia",
    "Montenegro",
    "Mozambique",
    "Namibia",
    "Nauru",
    "Nepal",
    "Nicaragua",
    "Níger",
    "Nigeria",
    "Noruega",
    "Nueva Zelanda",
    "Omán",
    "Países Bajos",
    "Pakistán",
    "Palaos",
    "Panamá",
    "Papúa Nueva Guinea",
    "Paraguay",
    "Perú",
    "Polonia",
    "Portugal",
    "Reino Unido",
    "República Centroafricana",
    "República Checa",
    "República del Congo",
    "República Democrática del Congo",
    "República Dominicana",
    "Ruanda",
    "Rumanía",
    "Rusia",
    "Samoa",
    "San Cristóbal y Nieves",
    "San Marino",
    "San Vicente y las Granadinas",
    "Santa Lucía",
    "Santo Tomé y Príncipe",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leona",
    "Singapur",
    "Siria",
    "Somalia",
    "Sri Lanka",
    "Sudáfrica",
    "Sudán",
    "Sudán del Sur",
    "Suecia",
    "Suiza",
    "Surinam",
    "Tailandia",
    "Tanzania",
    "Tayikistán",
    "Timor Oriental",
    "Togo",
    "Tonga",
    "Trinidad y Tobago",
    "Túnez",
    "Turkmenistán",
    "Turquía",
    "Ucrania",
    "Uganda",
    "Uruguay",
    "Uzbekistán",
    "Vanuatu",
    "Vaticano",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Yibuti",
    "Zambia",
    "Zimbabue",
  ],
};

const translate = {
  pt: {
    name: "",
    firstName: "Nome",
    middleName: "Nome do meio (Opcional)",
    lastName: "Sobrenome",
    email: "Endereço de e-mail",
    email2: "E-mail comercial (Opcional)",
    languages: "Idiomas",
    ddi: "código do país (ex: +55)",
    cellPhone: "Informe seu número de telefone (ex: 11999999999)",
    photoId:
      "Anexe uma foto recente de frente com fundo branco (estilo passaporte)",
    idType: "Tipo de documento",
    idNumber: "Número do documento",
    idCountry: "País emissor do documento",
    documentPhotoId:
      "Anexe uma imagem nítida do seu documento de identificação",
    dateOfBirth: "Data de nascimento",
    currentCountry: "País",
    nationality: "Nacionalidade",
    currentState: "Estado ou província",
    currentCity: "Cidade",
    currentAddress: "Endereço",
    currentZipCode: "CEP",
    dependentsWithDisability:
      "Você possui dependentes (crianças ou pessoas com deficiência)? Se sim, quantos?",
    maritalStatus: "Estado civil",
    educationLevel: "Nível de escolaridade",
    currentOccupancy: "Qual é sua profissão ou ocupação atual?",
    befoareOccupancy: "Qual foi seu cargo mais recente?",
    workExperience:
      "Resuma sua experiência profissional nos últimos 3 anos",
    willingToRelocate:
      "Você está disposto(a) a se mudar para outro estado dos EUA, caso haja uma vaga compatível com seu perfil?",
    ownVehicle: "Você possui veículo próprio?",
    interviewer: "Nome da pessoa responsável pela sua entrevista",
    emergencyContactName: "Nome do contato de emergência",
    emergencyContactEmail: "E-mail do contato de emergência",
    emergencyContactDdi: "código do país",
    emergencyContactPhone: "Telefone do contato de emergência",
    button: "Registrar",
  },
  en: {
    name: "",
    firstName: "First Name",
    middleName: "Middle Name (Optional)",
    lastName: "Last Name",
    email: "Email Address",
    email2: "Email Business (Optional)",
    languages: "Languages",
    ddi: "country code (ex: +1)",
    cellPhone: "Please provide your phone number (e.g. 1234567890)",
    photoId:
      "Attach a recent front-facing photo with a white background (passport-style)",
    idType: "ID Type",
    idNumber: "ID Number",
    idCountry: "Country ID",
    documentPhotoId: "Attach a clear image of your identification document.",
    dateOfBirth: "Date of Birth",
    currentCountry: "Country",
    nationality: "Nationality",
    currentState: "State or Province",
    currentCity: "City",
    currentAddress: "Address",
    currentZipCode: "ZIP Code",
    dependentsWithDisability:
      "Do you have any dependents (underage children or individuals with disabilities)? If so, how many?",
    maritalStatus: "Marital Status",
    educationLevel: "Education Level",
    currentOccupancy:
      "What is your current profession or occupation?",
    befoareOccupancy: "What was your most recent job position?",
    workExperience:
      "Briefly summarize your work experience in the last three (3) years",
    willingToRelocate:
      "Are you willing to relocate to another U.S. state if a position matching your qualifications becomes available?",
    ownVehicle: "Do you own a vehicle?",
    interviewer: "Name of the person responsible for conducting your interview",
    emergencyContactName: "Emergency Contact Name",
    emergencyContactEmail: "Emergency Contact Email",
    emergencyContactDdi: "country code",
    emergencyContactPhone: "Emergency Contact Phone",
    button: "Register",
  },
  es: {
    name: "",
    firstName: "Nombre",
    middleName: "Segundo Nombre (Opcional)",
    lastName: "Apellidos",
    email: "Dirección de correo electrónico",
    email2: "Email Business (Opcional)",
    languages: "Languages",
    ddi: "código de país (ex: +1)",
    cellPhone: "Número de teléfono (e.g. 1234567890)",
    photoId:
      "Adjunte una foto suya reciente de frente, con fondo blanco, tipo pasaporte",
    idType: "Tipo de documento de identificación",
    idNumber: "Número de Documento de Identificación",
    idCountry: "País que emite documento de identificación",
    documentPhotoId: "Adjunte una imagen de su documento de identificación",
    dateOfBirth: "Fecha de Nacimiento",
    currentCountry: "País ",
    nationality: "Nacionalidad",
    currentState: "Estado o Provincia",
    currentCity: "Ciudad",
    currentAddress: "Dirección",
    currentZipCode: "Código Postal",
    dependentsWithDisability:
      "¿Tiene personas a su cargo (hijos menores de edad o personas en condición de discapacidad)? ¿Cuántas?",
    maritalStatus: "Estado Civil",
    educationLevel: "Nivel Educativo",
    currentOccupancy: "Profesión u oficio",
    befoareOccupancy: "Último cargo desempeñado",
    workExperience:
      "Resumen de experiencia laboral en los últimos tres (3) años",
    willingToRelocate:
      "¿Está dispuesto/a a trasladarse a otro estado dentro de EE. UU. si hay una vacante acorde a su perfil?",
    ownVehicle: "¿Cuenta con vehículo propio?",
    interviewer: "Nombre del responsable que le realizó la entrevista",
    emergencyContactName: "Nombre del Contacto de Emergencia",
    emergencyContactEmail: "Correo Electrónico del Contacto de Emergencia",
    emergencyContactDdi: "código de país (ex: +1)",
    emergencyContactPhone: "Teléfono del Contacto de Emergencia",
    button: "Registrar",
  },
};

const translateBoolean = {
  pt: {
    true: "Sim",
    false: "Nao",
  },
  en: {
    true: "Yes",
    false: "No",
  },
  es: {
    true: "Si",
    false: "No",
  },
};

type Candidate = {
  name: string | null;
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  email: string | null;
  email2: string | null;
  languages: string | null; // Alterado para array de strings
  ddi: string | null;
  cellPhone: string | null;
  photoId: File | null; // base64 da foto do candidato
  idType: string | null;
  idNumber: string | null;
  idCountry: string | null; // Novo campo para país do documento
  documentPhotoId: File | null; // base64 da foto do documento
  dateOfBirth: string | null;
  currentCountry: string | null;
  nationality: string | null;
  currentState: string | null;
  currentCity: string | null;
  currentAddress: string | null;
  currentZipCode: string | null;
  dependentsWithDisability: string | null;
  maritalStatus: string | null;
  educationLevel: string | null;
  currentOccupancy: string | null;
  befoareOccupancy: string | null;
  workExperience: string | null;
  willingToRelocate: boolean | null;
  ownVehicle: boolean | null;
  interviewer: string | null;
  emergencyContactName: string | null;
  emergencyContactEmail: string | null;
  emergencyContactPhone: string | null;
  emergencyContactDdi: string | null;
};

type Employee = {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  department: string;
  jobTitle: string;
  birthdate: string | null;
  managerId: number | null;
  hiredDate: string | null;
  terminationDate: string | null;
  terminationReason: string | null;
  status: string;
  salary: number | null;
  gender: string | null;
  numberOfDependents: number | null;
  baseSalary: number | null;
  frequencySalary: string | null;
  weeklyBonus: number | null;
  totalWeekIncome: number | null;
  quarterBonus: number | null;
  annualIncome: number | null;
  adpW2Amount: number | null;
  workMarketAdp: string | null;
  directPay: number | null;
  documentType: string | null;
  documentNumber: string | null;
  createdBy: string | null;
  createdAt: string;
  modifiedBy: string | null;
  modifiedAt: string;
};

interface CountryIdTypeMap {
  [countryName: string]: string[];
}

const countryIdTypes: {
  pt: CountryIdTypeMap;
  en: CountryIdTypeMap;
  es: CountryIdTypeMap;
} = {
  pt: {
    Afeganistão: [
      "Passaporte",
      "Cédula Nacional",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Albânia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Alemanha: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Andorra: [
      "Documento Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Angola: [
      "Bilhete de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Antígua e Barbuda": [
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Arábia Saudita": [
      "Iqama (Permissão de Residência)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Argélia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Argentina: [
      "DNI (Documento Nacional de Identidade)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Armênia: [
      "Passaporte",
      "Carteira Nacional de Identidade",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Austrália: ["Carteira de Habilitação", "Passaporte", "Outros documentos"],
    Áustria: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Azerbaijão: [
      "Passaporte",
      "Carteira Nacional de Identidade",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Bahamas: ["Passaporte", "Carteira de Habilitação", "Outros documentos"],
    Bangladesh: [
      "NID (Carteira Nacional de Identidade)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Barbados: ["Passaporte", "Carteira de Habilitação", "Outros documentos"],
    Bahrein: [
      "Carteira Civil",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Bélgica: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Belize: ["Passaporte", "Carteira de Habilitação", "Outros documentos"],
    Benin: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Bielorrússia: [
      "Passaporte",
      "Carteira Nacional de Identidade",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Mianmar: [
      "Carteira Nacional de Registro",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Bolívia: [
      "Cédula de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Bósnia e Herzegovina": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Botswana: [
      "Omang (Identidade Nacional)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Brasil: [
      "CPF",
      "RG (Registro Geral)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Brunei: [
      "Passaporte",
      "Carteira de Identidade",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Bulgária: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Burkina Faso": [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Burundi: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Butão: [
      "Passaporte",
      "Carteira Nacional de Identidade",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Cabo Verde": [
      "Bilhete de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Camarões: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Canadá: [
      "Carteira de Motorista",
      "Passaporte",
      "Carteira de Identidade",
      "Outros documentos",
    ],
    Chile: [
      "Cédula de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    China: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Colômbia: [
      "Cédula de Cidadania",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Costa Rica": [
      "Cédula de Identidad",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Croácia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Cuba: [
      "Carnê de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Dinamarca: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Egito: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "El Salvador": [
      "Documento Único de Identidad",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Emirados Árabes Unidos": [
      "Carteira de Residência",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Equador: [
      "Cédula de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Espanha: [
      "Documento Nacional de Identidad (DNI)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Estados Unidos": [
      "Carteira de Motorista",
      "Passaporte",
      "Número de Seguro Social (SSN)",
      "Outros documentos",
    ],
    Estônia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Etiópia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Fiji: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Filipinas: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Finlândia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    França: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Gabão: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Gâmbia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Gana: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Grécia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Guatemala: [
      "Documento Personal de Identificación",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Guiana: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Guiné: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Guiné-Bissau": [
      "Bilhete de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Haiti: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Holanda: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Honduras: [
      "Documento Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Hungria: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Iêmen: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Ilhas Fiji": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Ilhas Salomão": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Índia: [
      "Aadhaar",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Indonésia: [
      "KTP (Carteira de Identidade)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Irã: [
      "Carteira de Identidade Nacional",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Iraque: [
      "Carteira de Identidade Nacional",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Irlanda: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Islândia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Israel: [
      "Teudat Zehut",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Itália: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Jamaica: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Japão: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Jordânia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Kuwait: [
      "Carteira Civil",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Laos: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Lesoto: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Letônia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Líbano: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Libéria: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Líbia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Liechtenstein: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Lituânia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Luxemburgo: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Macau: [
      "Bilhete de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Madagáscar: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Malásia: [
      "MyKad (Carteira de Identidade)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Malaui: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Maldivas: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Mali: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Malta: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Marrocos: [
      "Carteira de Identidade Nacional",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Maurício: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Mauritânia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    México: [
      "INE (Carteira de Identidade Nacional)",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Moldávia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Mônaco: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Mongólia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Montenegro: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Moçambique: [
      "Bilhete de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Namíbia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Nepal: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Nicarágua: [
      "Documento Único de Identidad",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Níger: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Nigéria: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Noruega: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Nova Zelândia": [
      "Carteira de Motorista",
      "Passaporte",
      "Carteira de Identidade",
      "Outros documentos",
    ],
    Omã: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Países Baixos": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Palau: ["Passaporte", "Carteira de Habilitação", "Outros documentos"],
    Panamá: [
      "Cédula de Identidad Personal",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Papua Nova Guiné": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Paquistão: [
      "Carteira de Identidade Nacional",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Paraguai: [
      "Cédula de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Peru: [
      "Documento Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Polônia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Portugal: [
      "Cartão de Cidadão",
      "Passaporte",
      "Carta de Condução",
      "Outros documentos",
    ],
    Quênia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Quirguistão: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Reino Unido": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "República Centro-Africana": [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "República Democrática do Congo": [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "República Dominicana": [
      "Cédula de Identidad y Electoral",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Romênia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Rússia: [
      "Passaporte Interno",
      "Passaporte Internacional",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Ruanda: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "San Marino": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "São Cristóvão e Nevis": [
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "São Tomé e Príncipe": [
      "Bilhete de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "São Vicente e Granadinas": [
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Senegal: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Serra Leoa": [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Sérvia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Síria: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Somália: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Sri Lanka": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Sudão: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Suécia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Suíça: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Suriname: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Tailândia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Taiwan: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Tanzânia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Togo: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    "Trinidad e Tobago": [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Tunísia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Turquia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Ucrânia: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Uganda: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Uruguai: [
      "Cédula de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Uzbequistão: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Vanuatu: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Venezuela: [
      "Cédula de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Vietnã: [
      "Carteira de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Zâmbia: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
    Zimbábue: [
      "Carteira Nacional de Identidade",
      "Passaporte",
      "Carteira de Habilitação",
      "Outros documentos",
    ],
  },
  en: {
    Afghanistan: [
      "Passport",
      "National ID Card",
      "Driver's License",
      "Other documents",
    ],
    Albania: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Germany: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Andorra: [
      "National Identity Document",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Angola: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Antigua and Barbuda": ["Passport", "Driver's License", "Other documents"],
    "Saudi Arabia": [
      "Iqama (Residence Permit)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Algeria: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Argentina: [
      "National Identity Document (DNI)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Armenia: [
      "Passport",
      "National Identity Card",
      "Driver's License",
      "Other documents",
    ],
    Australia: ["Driver's License", "Passport", "Other documents"],
    Austria: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Azerbaijan: [
      "Passport",
      "National Identity Card",
      "Driver's License",
      "Other documents",
    ],
    Bahamas: ["Passport", "Driver's License", "Other documents"],
    Bangladesh: [
      "NID (National Identity Card)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Barbados: ["Passport", "Driver's License", "Other documents"],
    Bahrain: ["Civil ID", "Passport", "Driver's License", "Other documents"],
    Belgium: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Belize: ["Passport", "Driver's License", "Other documents"],
    Benin: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Belarus: [
      "Passport",
      "National Identity Card",
      "Driver's License",
      "Other documents",
    ],
    Myanmar: [
      "National Registration Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Bolivia: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Bosnia and Herzegovina": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Botswana: [
      "Omang (National Identity)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Brazil: [
      "CPF",
      "RG (General Registry)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Brunei: [
      "Passport",
      "Identity Card",
      "Driver's License",
      "Other documents",
    ],
    Bulgaria: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Burkina Faso": [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Burundi: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Bhutan: [
      "Passport",
      "National Identity Card",
      "Driver's License",
      "Other documents",
    ],
    "Cape Verde": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Cameroon: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Canada: [
      "Driver's License",
      "Passport",
      "Identity Card",
      "Other documents",
    ],
    Chile: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    China: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Colombia: [
      "Citizenship Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Costa Rica": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Croatia: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Cuba: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Denmark: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Egypt: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "El Salvador": [
      "Unique Identity Document",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "United Arab Emirates": [
      "Residence Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Ecuador: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Spain: [
      "National Identity Document (DNI)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "United States": [
      "Driver's License",
      "Passport",
      "Social Security Number (SSN)",
      "Other documents",
    ],
    Estonia: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Ethiopia: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Fiji: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Philippines: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Finland: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    France: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Gabon: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Gambia: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Ghana: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Greece: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Guatemala: [
      "Personal Identification Document",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Guyana: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Guinea: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Guinea-Bissau": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Haiti: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Honduras: [
      "National Identity Document",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Hungary: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Yemen: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Fiji Islands": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Solomon Islands": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    India: ["Aadhaar", "Passport", "Driver's License", "Other documents"],
    Indonesia: [
      "KTP (Identity Card)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Iran: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Iraq: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Ireland: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Iceland: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Israel: ["Teudat Zehut", "Passport", "Driver's License", "Other documents"],
    Italy: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Jamaica: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Japan: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Jordan: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Kuwait: ["Civil ID", "Passport", "Driver's License", "Other documents"],
    Laos: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Lesotho: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Latvia: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Lebanon: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Liberia: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Libya: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Liechtenstein: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Lithuania: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Luxembourg: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Macau: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Madagascar: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Malaysia: [
      "MyKad (Identity Card)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Malawi: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Maldives: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Mali: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Malta: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Morocco: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Mauritius: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Mauritania: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Mexico: [
      "INE (National Identity Card)",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Moldova: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Monaco: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Mongolia: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Montenegro: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Mozambique: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Namibia: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Nepal: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Nicaragua: [
      "Unique Identity Document",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Niger: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Nigeria: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Norway: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "New Zealand": [
      "Driver's License",
      "Passport",
      "Identity Card",
      "Other documents",
    ],
    Oman: ["Identity Card", "Passport", "Driver's License", "Other documents"],
    Netherlands: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Palau: ["Passport", "Driver's License", "Other documents"],
    Panama: [
      "Personal Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Papua New Guinea": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Pakistan: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Paraguay: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Peru: [
      "National Identity Document",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Poland: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Portugal: [
      "Citizen Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Kenya: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Kyrgyzstan: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "United Kingdom": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Central African Republic": [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Democratic Republic of the Congo": [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Dominican Republic": [
      "Identity and Electoral Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Romania: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Russia: [
      "Internal Passport",
      "International Passport",
      "Driver's License",
      "Other documents",
    ],
    Rwanda: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "San Marino": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Saint Kitts and Nevis": [
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Sao Tome and Principe": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Saint Vincent and the Grenadines": [
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Senegal: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Sierra Leone": [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Serbia: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Syria: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Somalia: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Sri Lanka": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Sudan: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Sweden: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Switzerland: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Suriname: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Thailand: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Taiwan: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Tanzania: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Togo: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    "Trinidad and Tobago": [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Tunisia: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Turkey: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Ukraine: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Uganda: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Uruguay: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Uzbekistan: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Vanuatu: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Venezuela: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Vietnam: [
      "Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Zambia: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
    Zimbabwe: [
      "National Identity Card",
      "Passport",
      "Driver's License",
      "Other documents",
    ],
  },
  es: {
    Afganistán: [
      "Pasaporte",
      "Documento Nacional de Identidad",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Albania: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Alemania: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Andorra: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Angola: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Antigua y Barbuda": [
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Arabia Saudita": [
      "Iqama (Permiso de Residencia)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Argelia: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Argentina: [
      "Documento Nacional de Identidad (DNI)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Armenia: [
      "Pasaporte",
      "Documento Nacional de Identidad",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Australia: ["Licencia de Conducir", "Pasaporte", "Otros documentos"],
    Austria: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Azerbaiyán: [
      "Pasaporte",
      "Documento Nacional de Identidad",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Bahamas: ["Pasaporte", "Licencia de Conducir", "Otros documentos"],
    Bangladesh: [
      "NID (Documento Nacional de Identidad)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Barbados: ["Pasaporte", "Licencia de Conducir", "Otros documentos"],
    Baréin: [
      "Cédula Civil",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Bélgica: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Belice: ["Pasaporte", "Licencia de Conducir", "Otros documentos"],
    Benín: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Bielorrusia: [
      "Pasaporte",
      "Documento Nacional de Identidad",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Birmania: [
      "Tarjeta Nacional de Registro",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Bolivia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Bosnia y Herzegovina": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Botsuana: [
      "Omang (Documento Nacional de Identidad)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Brasil: [
      "CPF",
      "RG (Registro General)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Brunéi: [
      "Pasaporte",
      "Documento de Identidad",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Bulgaria: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Burkina Faso": [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Burundi: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Bután: [
      "Pasaporte",
      "Documento Nacional de Identidad",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Cabo Verde": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Camerún: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Canadá: [
      "Licencia de Conducir",
      "Pasaporte",
      "Documento de Identidad",
      "Otros documentos",
    ],
    Chile: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    China: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Colombia: [
      "Cédula de Ciudadanía",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Costa Rica": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Croacia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Cuba: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Dinamarca: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Egipto: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "El Salvador": [
      "Documento Único de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Emiratos Árabes Unidos": [
      "Tarjeta de Residencia",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Ecuador: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    España: [
      "Documento Nacional de Identidad (DNI)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Estados Unidos": [
      "Licencia de Conducir",
      "Pasaporte",
      "Número de Seguro Social (SSN)",
      "Otros documentos",
    ],
    Estonia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Etiopía: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Fiyi: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Filipinas: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Finlandia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Francia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Gabón: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Gambia: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Ghana: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Grecia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Guatemala: [
      "Documento Personal de Identificación",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Guyana: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Guinea: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Guinea-Bisáu": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Haití: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Holanda: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Honduras: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Hungría: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Yemen: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Islas Fiyi": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Islas Salomón": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    India: ["Aadhaar", "Pasaporte", "Licencia de Conducir", "Otros documentos"],
    Indonesia: [
      "KTP (Documento de Identidad)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Irán: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Iraq: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Irlanda: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Islandia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Israel: [
      "Teudat Zehut",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Italia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Jamaica: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Japón: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Jordania: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Kuwait: [
      "Cédula Civil",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Laos: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Lesoto: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Letonia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Líbano: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Liberia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Libia: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Liechtenstein: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Lituania: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Luxemburgo: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Macao: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Madagascar: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Malasia: [
      "MyKad (Documento de Identidad)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Malaui: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Maldivas: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Malí: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Malta: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Marruecos: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Mauricio: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Mauritania: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    México: [
      "INE (Documento Nacional de Identidad)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Moldavia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Mónaco: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Mongolia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Montenegro: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Mozambique: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Namibia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Nepal: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Nicaragua: [
      "Documento Único de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Níger: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Nigeria: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Noruega: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Nueva Zelanda": [
      "Licencia de Conducir",
      "Pasaporte",
      "Documento de Identidad",
      "Otros documentos",
    ],
    Omán: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Países Bajos": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Palaos: ["Pasaporte", "Licencia de Conducir", "Otros documentos"],
    Panamá: [
      "Documento Personal de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Papúa Nueva Guinea": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Paraguay: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Perú: [
      "Documento Nacional de Identidad (DNI)",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Polonia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Portugal: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Reino Unido": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "República Centroafricana": [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "República Checa": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "República del Congo": [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "República Democrática del Congo": [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "República Dominicana": [
      "Cédula de Identidad y Electoral",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Ruanda: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Rumania: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Rusia: [
      "Pasaporte",
      "Documento Nacional de Identidad",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Samoa: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "San Cristóbal y Nieves": [
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "San Marino": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "San Vicente y las Granadinas": [
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Santa Lucía": ["Pasaporte", "Licencia de Conducir", "Otros documentos"],
    Senegal: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Serbia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Seychelles: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Sierra Leona": [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Singapur: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Siria: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Somalia: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Sudán: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Suecia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Suiza: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Surinam: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Tailandia: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Taiwán: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Tanzania: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Togo: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    "Trinidad y Tobago": [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Túnez: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Turquía: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Ucrania: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Uganda: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Uruguay: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Uzbekistán: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Vanuatu: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Venezuela: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Vietnam: [
      "Documento de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Zambia: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
    Zimbabue: [
      "Documento Nacional de Identidad",
      "Pasaporte",
      "Licencia de Conducir",
      "Otros documentos",
    ],
  },
};

type Language = "pt" | "en" | "es";

const Languages = ["Spanish", "English", "Portuguese", "Other"];

// type Country = {
//   code: string;
//   name: string;
//   geonameId: number;
// };

const cabecalhos = {
  pt: {
    ddi: "DDI",
    personal: "INFORMAÇÕES PESSOAIS",
    contacto: "INFORMAÇÕES DE CONTATO",
    identification: "IDENTIFICAÇÃO",
    residence: "RESIDÊNCIA ATUAL",
    occupacion: "FORMAÇÃO E OCUPAÇÃO",
    avaiability: "DISPONIBILIDADE",
    emergency: "CONTATO DE EMERGÊNCIA",
    documents: "DOCUMENTOS ADICIONAIS",
    interview: "ENTREVISTA",
  },
  en: {
    ddi: "DDI",
    personal: "PERSONAL INFORMATION",
    contacto: "CONTACT INFORMATION",
    identification: "IDENTIFICATION",
    residence: "CURRENT RESIDENCE",
    occupacion: "EDUCATION AND OCCUPATION",
    avaiability: "AVAILABILITY",
    emergency: "EMERGENCY CONTACT",
    documents: "ADDTIONAL DOCUMENTS",
    interview: "INTERVIEW",
  },
  es: {
    ddi: "DDI",
    personal: "INFORMACIÓN PERSONAL",
    contacto: "DATOS DE CONTACTO",
    identification: "IDENTIFICACIÓN",
    residence: "RESIDENCIA ACTUAL",
    occupacion: "FORMACIÓN Y OCUPACIÓN",
    avaiability: "DISPONIBILIDAD",
    emergency: "CONTACTO DE EMERGENCIA",
    documents: "DOCUMENTOS ADICIONALES",
    interview: "ENTREVISTA",
  },
};

const descriptionLanguage = {
  pt: "(Pressione Control + Todos os idiomas selecionados)",
  en: "(Press Control + All Selected Languages)",
  es: "(Presione Control + Todos los idiomas seleccionados)",
};

// JOBTITLE moved to backend - now handled by /Employee/Interviewers endpoint
// This ensures consistent filtering between frontend and backend

const SingnUp = () => {
  const router = useRouter();

  const [isDesktop, setIsDesktop] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [emailErrorPerson, setEmailErrorPerson] = useState("");
  const [employee, setEmployee] = useState<Employee[]>([]);
  // const [selectCountry, setSelectCountry] = useState<string | null>();
  // const [country, setCountry] = useState<Country[]>([]);
  // const [states, setStates] = useState<string[]>([]);
  // const [cities, setCities] = useState<string[]>([]);
  const [countryIdType, setCountryIdTypes] = useState<string[]>([]);
  const [selectdLanguage, setSelectdLanguage] = useState<Language>("es");

  const [payload, setPayload] = useState<Candidate>({
    name: null,
    firstName: null,
    middleName: null,
    lastName: null,
    email: null,
    email2: null,
    languages: null,
    ddi: null,
    cellPhone: null,
    photoId: null,
    idType: null,
    idNumber: null,
    idCountry: null,
    documentPhotoId: null,
    dateOfBirth: null,
    currentCountry: null,
    nationality: null,
    currentState: null,
    currentCity: null,
    currentAddress: null,
    currentZipCode: null,
    dependentsWithDisability: "0",
    maritalStatus: null,
    educationLevel: null,
    currentOccupancy: null,
    befoareOccupancy: null,
    workExperience: null,
    willingToRelocate: false,
    ownVehicle: false,
    interviewer: null,
    emergencyContactName: null,
    emergencyContactEmail: null,
    emergencyContactPhone: null,
    emergencyContactDdi: null,
  });

  useEffect(() => {
    function checkIsDesktop() {
      setIsDesktop(window.innerWidth > 768);
    }

    checkIsDesktop();
    window.addEventListener("resize", checkIsDesktop);

    return () => window.removeEventListener("resize", checkIsDesktop);
  }, []);

  function getCountryIdTypes(country: string) {
    setCountryIdTypes(countryIdTypes[selectdLanguage][country] || []);
  }

  // async function getCountry() {
  //   try {
  //     const response = await api.get("/Candidates/Countries", {
  //       params: {
  //         username: "mibrvictor",
  //       },
  //     });

  //     const countries = response.data.data.countries;

  //     console.log(countries);
  //     setCountry(countries);
  //   } catch (error) {
  //     console.error(`Erro ao buscar paises:`, error);
  //     return [];
  //   }
  // }

  // async function getStateByCountry(country: string) {
  //   try {
  //     const response = await api.get("/Candidates/StatesByCountry", {
  //       params: {
  //         country: country,
  //         username: "mibrvictor",
  //       },
  //     });

  //     const resp = response.data.data.states;

  //     console.log(resp);
  //     setStates(resp);
  //   } catch (error) {
  //     console.error(`Erro ao buscar estados:`, error);
  //     return [];
  //   }
  // }

  // async function getCitiesByState(state: string) {
  //   try {
  //     const response = await api.get("/Candidates/CitiesByState", {
  //       params: {
  //         q: state,
  //         country: selectCountry,
  //         featureClass: "P",
  //         maxRows: 1000,
  //         username: "mibrvictor",
  //       },
  //     });

  //     const cities = response.data.data.cities;

  //     console.log(cities);
  //     setCities(cities);
  //   } catch (error) {
  //     console.error(`Erro ao buscar cidades para ${state}:`, error);
  //     return [];
  //   }
  // }

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        console.log("🚀 Iniciando busca de interviewers...");
        console.log("📡 URL da API:", api.defaults.baseURL);

        // Endpoint público - não requer autenticação
        console.log("📤 Fazendo requisição para /Employee/Interviewers...");
        const response = await api.get("/Employee/Interviewers");
        console.log("✅ Resposta da API recebida:", response.data);

        if (response.data && response.data.data) {
          console.log("📊 Total de interviewers retornados pela API:", response.data.data.length);

          // Filtrar apenas funcionários ativos e ordenar
          const employees = response.data.data
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .filter((emp: any) => {
              // Verificar se o funcionário tem status "ACTIVE"
              const isActive = emp.status === "ACTIVE";

              if (!isActive) {
                console.log("⏭️ Funcionário inativo filtrado:", emp.fullName, "Status:", emp.status);
              }

              return isActive;
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .sort((a: any, b: any) =>
              a.fullName.localeCompare(b.fullName, "pt", {
                sensitivity: "base",
              })
            );

          console.log("🎯 Interviewers ativos após filtro e ordenação:", employees);
          console.log("📈 Total de interviewers ativos:", employees.length);
          console.log("❌ Total de inativos filtrados:", response.data.data.length - employees.length);

          setEmployee(employees);
        } else {
          console.error("❌ Estrutura de dados inesperada:", response.data);
          setEmployee([]);
        }
      } catch (error) {
        console.error("💥 Erro ao buscar interviewers:", error);
        setEmployee([]);
      }
    };

    fetchEmployees();
  }, []);

  const [files, setFiles] = useState<{
    photoId?: File;
    documentPhotoId?: File;
    additionalDocuments?: File[];
  }>({});

  const singup = async () => {
    // Prevenir múltiplos cliques
    if (isLoading) return;

    if (!validateForm(payload)) return;

    try {
      setIsLoading(true);

      // Preparar payload com imagens
      const finalPayload = { ...payload };

      // Converter imagens para base64 se existirem
      if (files.photoId) {
        finalPayload.photoId = files.photoId;
      }

      if (files.documentPhotoId) {
        finalPayload.documentPhotoId = files.documentPhotoId;
      }

      finalPayload.cellPhone = `${finalPayload.ddi}${finalPayload.cellPhone}`;
      finalPayload.emergencyContactPhone = `${finalPayload.emergencyContactDdi}${finalPayload.emergencyContactPhone}`;

      await sendLargePayload(finalPayload);

      // Manter loading ativo durante o redirecionamento
      router.push("/congratulations");
    } catch (error) {
      setIsLoading(false);
      console.error("Erro ao cadastrar candidato:", error);
    }
  };

  const sendLargePayload = async (payload: Candidate) => {
    // Recuperar API Key do ambiente
    const apiKey = process.env.NEXT_PUBLIC_SIGNUP_API_KEY;

    // Primeiro enviar dados sem arquivos
    const { ...rest } = payload;
    const response = await api.post("/Candidates", rest, {
      headers: {
        "X-API-Key": apiKey,
      },
    });
    const candidateId = response.data.data.id;

    if (files.photoId) {
      const formData = new FormData();
      formData.append("entityName", "Candidates");
      formData.append("destination", "Documents");
      formData.append("entityId", candidateId);
      const extension = files.photoId.name.split(".").pop();
      formData.append("files", files.photoId, `Selfie.${extension}`);
      await api.post(`/File/Upload`, formData, {
        headers: {
          "X-API-Key": apiKey,
        },
      });
    }

    if (files.documentPhotoId) {
      const formData2 = new FormData();
      formData2.append("entityName", "Candidates");
      formData2.append("destination", "Documents");
      formData2.append("entityId", candidateId);
      const extension = files.documentPhotoId.name.split(".").pop();
      formData2.append("files", files.documentPhotoId, `Document.${extension}`);
      await api.post(`/File/Upload`, formData2, {
        headers: {
          "X-API-Key": apiKey,
        },
      });
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    if (!inputRef.current) return;

    const maskOptions = {
      mask: "+1 (000) 000-0000",
    };

    const mask = IMask(inputRef.current, maskOptions);

    return () => {
      mask.destroy();
    };
  }, []);

  function isValidEmail(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  const validateForm = (payload: Candidate) => {
    const requiredFields = [
      {
        field: payload.firstName,
        message: {
          pt: "Nome é obrigatório.",
          en: "First Name is required.",
          es: "El nombre es obligatorio.",
        },
      },
      {
        field: payload.lastName,
        message: {
          pt: "Sobrenome é obrigatório.",
          en: "Last Name is required.",
          es: "El apellido es obligatorio.",
        },
      },
      {
        field: payload.dateOfBirth,
        message: {
          pt: "Data de nascimento é obrigatória.",
          en: "Date of Birth is required.",
          es: "La fecha de nacimiento es obligatoria.",
        },
      },
      {
        field: payload.nationality,
        message: {
          pt: "Nacionalidade é obrigatória.",
          en: "Nationality is required.",
          es: "La nacionalidad es obligatoria.",
        },
      },
      {
        field: payload.maritalStatus,
        message: {
          pt: "Estado civil é obrigatório.",
          en: "Marital Status is required.",
          es: "El estado civil es obligatorio.",
        },
      },
      {
        field: payload.dependentsWithDisability,
        message: {
          pt: "Informe dependentes com deficiência.",
          en: "Dependents With Disability is required.",
          es: "Dependientes con discapacidad son obligatorios.",
        },
      },
      {
        field: payload.cellPhone,
        message: {
          pt: "Celular é obrigatório.",
          en: "Cell Phone is required.",
          es: "El teléfono celular es obligatorio.",
        },
      },
      {
        field: payload.ddi,
        message: {
          pt: "Código do país é obrigatório.",
          en: "Country code is required.",
          es: "El código de país es obligatorio.",
        },
      },
      {
        field: payload.email,
        message: {
          pt: "E-mail é obrigatório.",
          en: "Email is required.",
          es: "El correo electrónico es obligatorio.",
        },
        isEmail: true,
      },
      {
        field: payload.idCountry,
        message: {
          pt: "País do documento é obrigatório.",
          en: "ID Country is required.",
          es: "El país del documento es obligatorio.",
        },
      },
      {
        field: payload.idType,
        message: {
          pt: "Tipo de documento é obrigatório.",
          en: "ID Type is required.",
          es: "El tipo de documento es obligatorio.",
        },
      },
      {
        field: payload.idNumber,
        message: {
          pt: "Número do documento é obrigatório.",
          en: "ID Number is required.",
          es: "El número del documento es obligatorio.",
        },
      },
      {
        field: payload.currentState,
        message: {
          pt: "Estado atual é obrigatório.",
          en: "Current State is required.",
          es: "El estado actual es obligatorio.",
        },
      },
      {
        field: payload.currentCity,
        message: {
          pt: "Cidade atual é obrigatória.",
          en: "Current City is required.",
          es: "La ciudad actual es obligatoria.",
        },
      },
      {
        field: payload.currentAddress,
        message: {
          pt: "Endereço atual é obrigatório.",
          en: "Current Address is required.",
          es: "La dirección actual es obligatoria.",
        },
      },
      {
        field: payload.educationLevel,
        message: {
          pt: "Nível de escolaridade é obrigatório.",
          en: "Education Level is required.",
          es: "El nivel educativo es obligatorio.",
        },
      },
      {
        field: payload.currentOccupancy,
        message: {
          pt: "Ocupação atual é obrigatória.",
          en: "Current Occupancy is required.",
          es: "La ocupación actual es obligatoria.",
        },
      },
      {
        field: payload.befoareOccupancy,
        message: {
          pt: "Ocupação anterior é obrigatória.",
          en: "Before Occupancy is required.",
          es: "La ocupación anterior es obligatoria.",
        },
      },
      {
        field: payload.languages,
        message: {
          pt: "Idiomas são obrigatórios.",
          en: "Languages are required.",
          es: "Los idiomas son obligatorios.",
        },
      },
      {
        field: payload.workExperience,
        message: {
          pt: "Experiência profissional é obrigatória.",
          en: "Work Experience is required.",
          es: "La experiencia laboral es obligatoria.",
        },
      },
      {
        field: payload.emergencyContactName,
        message: {
          pt: "Nome do contato de emergência é obrigatório.",
          en: "Emergency Contact Name is required.",
          es: "El nombre del contacto de emergencia es obligatorio.",
        },
      },
      {
        field: payload.emergencyContactEmail,
        message: {
          pt: "E-mail do contato de emergência é obrigatório.",
          en: "Emergency Contact Email is required.",
          es: "El correo electrónico del contacto de emergencia es obligatorio.",
        },
        isEmail: true,
      },
      {
        field: payload.emergencyContactPhone,
        message: {
          pt: "Telefone do contato de emergência é obrigatório.",
          en: "Emergency Contact Phone is required.",
          es: "El teléfono del contacto de emergencia es obligatorio.",
        },
      },
      {
        field: payload.interviewer,
        message: {
          pt: "Entrevistador é obrigatório.",
          en: "Interviewer is required.",
          es: "El entrevistador es obligatorio.",
        },
      },
    ];

    for (const { field, message, isEmail } of requiredFields) {
      const localizedMessage = message[selectdLanguage];
      if (!field || (typeof field === "string" && field.trim() === "")) {
        alert(localizedMessage);
        return false;
      }

      if (isEmail && !isValidEmail(field.toString())) {
        const emailErrorMessage = {
          pt: `Formato de e-mail inválido: ${localizedMessage}`,
          en: `Invalid email format: ${localizedMessage}`,
          es: `Formato de correo electrónico inválido: ${localizedMessage}`,
        };
        alert(emailErrorMessage[selectdLanguage]);
        return false;
      }
    }

    // Validação específica para arquivos obrigatórios
    if (!files.photoId) {
      const message = {
        pt: "Selfie é obrigatória.",
        en: "Selfie is required.",
        es: "La selfie es obligatoria.",
      };
      alert(message[selectdLanguage]);
      return false;
    }

    if (!files.documentPhotoId) {
      const message = {
        pt: "Foto do documento é obrigatória.",
        en: "Document photo is required.",
        es: "La foto del documento es obligatoria.",
      };
      alert(message[selectdLanguage]);
      return false;
    }

    return true;
  };

  return (
    <div className="container mx-auto">
      {isLoading}
      <section className="pt-16 lg:pt-5 pb-16"></section>
      <section className="p-5 justify-center items-center container">
        <div className="col-span-12 xl:col-span-4">
          <div className="grid grid-cols-12 gap-2">
            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Form Language
              </label>

              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-marital"
                  aria-label="Nacionalidad / Nationality"
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={selectdLanguage ?? ""}
                  onChange={(e) =>
                    setSelectdLanguage(e.target.value as Language)
                  }
                >
                  <option value="es">🇪🇸 Español</option>
                  <option value="en">🇺🇸 English</option>
                  <option value="pt">🇧🇷 Português</option>
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-12 mt-10">
              <b>{cabecalhos[selectdLanguage].personal}</b>
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].firstName} <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].firstName}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    firstName: e.target.value,
                    name: `${e.target.value} ${payload?.middleName ?? ""} ${
                      payload?.lastName
                    }`,
                  })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].middleName}
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].middleName}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    middleName: e.target.value,
                    name: `${payload?.firstName} ${e.target.value} ${
                      payload?.lastName ?? ""
                    }`,
                  })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].lastName}<span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].lastName}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    lastName: e.target.value,
                    name: `${payload?.firstName ?? ""} ${
                      payload?.middleName ?? ""
                    } ${e.target.value}`,
                  })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].dateOfBirth}<span className="required-asterisk">*</span>
              </label>
              <input
                type="date"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].dateOfBirth}
                value={payload.dateOfBirth || ""}
                onChange={(e) =>
                  setPayload({ ...payload, dateOfBirth: e.target.value })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].nationality}<span className="required-asterisk">*</span>
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-marital"
                  aria-label={translate[selectdLanguage].nationality}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.nationality ?? ""}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      nationality: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].nationality}
                  </option>
                  {nacionality[selectdLanguage].map((item) => {
                    return (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].maritalStatus}<span className="required-asterisk">*</span>
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-marital"
                  aria-label={translate[selectdLanguage].maritalStatus}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.maritalStatus ?? ""}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      maritalStatus: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].maritalStatus}
                  </option>
                  {maritalState.map((item) => {
                    return (
                      <option key={item.value} value={item.value}>
                        {item.label[selectdLanguage]}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].dependentsWithDisability} <span className="required-asterisk">*</span>
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-marital"
                  aria-label={
                    translate[selectdLanguage].dependentsWithDisability
                  }
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.dependentsWithDisability ?? ""}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      dependentsWithDisability: e.target.value,
                    })
                  }
                >
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="+5">+5</option>
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <b>{cabecalhos[selectdLanguage].contacto}</b>
            </div>

            <div className="col-span-5 xl:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].ddi} <span className="required-asterisk">*</span>
              </label>
              <input
                type="number"
                inputMode="numeric" // mostra teclado numérico em celulares
                pattern="[0-9]*" // para ajudar na validação e teclados virtuais
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].ddi}
                value={payload?.ddi ?? ""}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setPayload({ ...payload, ddi: onlyNums });
                }}
              />
            </div>

            <div className="col-span-7 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].cellPhone}<span className="required-asterisk">*</span>
              </label>
              <input
                type="number"
                inputMode="numeric" // mostra teclado numérico em celulares
                pattern="[0-9]*" // para ajudar na validação e teclados virtuais
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].cellPhone}
                value={payload?.cellPhone ?? ""}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setPayload({ ...payload, cellPhone: onlyNums });
                }}
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mt-1">
                {translate[selectdLanguage].email}<span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className={`w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100 ${
                  emailErrorPerson ? "border-red-500" : ""
                }`}
                placeholder={translate[selectdLanguage].email}
                value={payload?.email ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setPayload({ ...payload, email: value });

                  if (value === "" || isValidEmail(value)) {
                    setEmailErrorPerson("");
                  } else {
                    setEmailErrorPerson("Invalid Email");
                  }
                }}
              />
              {emailErrorPerson && (
                <p className="text-red-500 text-sm mt-1">{emailErrorPerson}</p>
              )}
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].email2}
              </label>
              <input
                type="text"
                className={`w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100 ${
                  emailError ? "border-red-500" : ""
                }`}
                placeholder={translate[selectdLanguage].email2}
                value={payload?.email2 ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setPayload({ ...payload, email2: value });

                  if (value === "" || isValidEmail(value)) {
                    setEmailError("");
                  } else {
                    setEmailError("Invalid Email");
                  }
                }}
              />
              {emailError && (
                <p className="text-red-500 text-sm mt-1">{emailError}</p>
              )}
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <b>{cabecalhos[selectdLanguage].identification}</b>
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].idCountry} <span className="required-asterisk">*</span>
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-marital"
                  aria-label={translate[selectdLanguage].idCountry}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.idCountry ?? ""}
                  onChange={(e) => {
                    setPayload({
                      ...payload,
                      idCountry: e.target.value,
                    });

                    getCountryIdTypes(e.target.value);
                  }}
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].idCountry}
                  </option>
                  {countries[selectdLanguage].map((item, idx) => {
                    return (
                      <option key={idx} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].idType} <span className="required-asterisk">*</span>
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-marital"
                  aria-label={translate[selectdLanguage].idType}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.idType ?? ""}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      idType: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].idType}
                  </option>
                  {countryIdType.map((item, idx) => {
                    return (
                      <option key={idx} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].idNumber} <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].idNumber}
                value={payload?.idNumber ?? ""}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    idNumber: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6 mt-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].documentPhotoId} <span className="required-asterisk">*</span>
              </label>
              <input
                type="file"
                accept="image/*"
                className="w-full text-gray-700"
                required
                onChange={(e) => {
                  if (e.target.files?.[0]) {
                    setFiles({ ...files, documentPhotoId: e.target.files[0] });
                  }
                }}
              />
              <p className="text-xs text-gray-500 mt-1">
                Use the camera to take a photo (on compatible devices)
              </p>
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <b>{cabecalhos[selectdLanguage].residence}</b>
            </div>

            {/*<div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].currentCountry}
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location"
                  aria-label={translate[selectdLanguage].currentCountry}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.currentCountry ?? ""}
                  onChange={(e) => {
                    setPayload({
                      ...payload,
                      currentCountry: e.target.value,
                    });

                    const code = country?.find(
                      (x) => x.name == e.target.value
                    )?.code;
                    setSelectCountry(code);
                    getStateByCountry(code as string);
                  }}
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].currentCountry}
                  </option>
                  {country?.map((country, idx) => (
                    <option key={idx} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>*/}

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].currentCountry} <span className="required-asterisk">*</span>
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-current-country"
                  aria-label={translate[selectdLanguage].currentCountry}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.currentCountry ?? ""}
                  onChange={(e) => {
                    setPayload({
                      ...payload,
                      currentCountry: e.target.value,
                    });
                  }}
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].currentCountry}
                  </option>
                  {countries[selectdLanguage].map((item, idx) => {
                    return (
                      <option key={idx} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            {/*<div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].currentState}
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location"
                  aria-label={translate[selectdLanguage].currentState}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.currentState ?? ""}
                  onChange={(e) => {
                    setPayload({
                      ...payload,
                      currentState: e.target.value,
                    });

                    getCitiesByState(e.target.value as string);
                  }}
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].currentState}
                  </option>
                  {states.map((state, idx) => (
                    <option key={idx} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
            </div>*/}

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].currentState} <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].currentState}
                onChange={(e) =>
                  setPayload({ ...payload, currentState: e.target.value })
                }
              />
            </div>

            {/*<div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                 {translate[selectdLanguage].currentCity} 
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location"
                  aria-label={translate[selectdLanguage].currentCity}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.currentCity ?? ""}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      currentCity: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].currentCity}
                  </option>
                  {cities.map((city, idx) => (
                    <option key={idx} value={city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>
            </div>*/}

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].currentCity} <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].currentCity}
                onChange={(e) =>
                  setPayload({ ...payload, currentCity: e.target.value })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].currentAddress}<span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].currentAddress}
                onChange={(e) =>
                  setPayload({ ...payload, currentAddress: e.target.value })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].currentZipCode} (Opcional /
                Optional)
              </label>
              <input
                type="text"
                maxLength={10} // 5 dígitos + hífen + 4 dígitos
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].currentZipCode}
                value={payload.currentZipCode || ""}
                onChange={(e) => {
                  // let val = e.target.value;

                  // // Remove tudo que não for número ou hífen
                  // val = val.replace(/[^\d-]/g, "");

                  // // Remove hífen caso esteja no lugar errado
                  // val = val.replace(/-+/g, "-");

                  // // Formata para 12345 ou 12345-6789
                  // if (val.length > 5) {
                  //   val = val.slice(0, 5) + "-" + val.slice(6, 10);
                  // }

                  setPayload({ ...payload, currentZipCode: e.target.value });
                }}
              />
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <b>{cabecalhos[selectdLanguage].occupacion}</b>
            </div>

            <div className="col-span-12 xl:col-span-6 mt-5">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].educationLevel} <span className="required-asterisk">*</span>
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-education"
                  aria-label={translate[selectdLanguage].educationLevel}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.educationLevel ?? ""}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      educationLevel: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    {translate[selectdLanguage].educationLevel}
                  </option>
                  {educationLevel.map((item) => {
                    return (
                      <option key={item.value} value={item.value}>
                        {item.label[selectdLanguage]}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-6 mt-5">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].currentOccupancy} <span className="required-asterisk">*</span>
              </label>
              <input
                type="email"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].currentOccupancy}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    currentOccupancy: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].workExperience}<span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].workExperience}
                onChange={(e) =>
                  setPayload({ ...payload, workExperience: e.target.value })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].befoareOccupancy}<span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].befoareOccupancy}
                value={payload?.befoareOccupancy ?? ""}
                onChange={(e) =>
                  setPayload({ ...payload, befoareOccupancy: e.target.value })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].languages} <span className="required-asterisk">*</span>{" "}
                {isDesktop && descriptionLanguage[selectdLanguage]}
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  multiple
                  value={payload.languages ? payload.languages.split(",") : []}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  onChange={(e) => {
                    const selected = Array.from(e.target.selectedOptions).map(
                      (option) => option.value
                    );
                    setPayload({ ...payload, languages: selected.join(",") });
                  }}
                >
                  {Languages.map((lang, idx) => (
                    <option key={idx} value={lang}>
                      {lang}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <b>{cabecalhos[selectdLanguage].avaiability}</b>
            </div>

            <div className="col-span-12 xl:col-span-6 mt-10">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].ownVehicle} <span className="required-asterisk">*</span>
              </label>
              <div className="col-span-12 xl:col-span-6">
                <select
                  className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                  value={payload?.ownVehicle ? "true" : "false"}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      ownVehicle: e.target.value == "true" ? true : false,
                    })
                  }
                >
                  <option value="false">
                    {translateBoolean[selectdLanguage].false}
                  </option>
                  <option value="true">
                    {translateBoolean[selectdLanguage].true}
                  </option>
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-6 mt-5">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].willingToRelocate} <span className="required-asterisk">*</span>
              </label>
              <div className="col-span-12 xl:col-span-6">
                <select
                  className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                  value={payload?.willingToRelocate ? "true" : "false"}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      willingToRelocate:
                        e.target.value == "true" ? true : false,
                    })
                  }
                >
                  <option value="false">
                    {translateBoolean[selectdLanguage].false}
                  </option>
                  <option value="true">
                    {translateBoolean[selectdLanguage].true}
                  </option>
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <b>{cabecalhos[selectdLanguage].emergency}</b>
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].emergencyContactName}<span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].emergencyContactName}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    emergencyContactName: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-span-5 xl:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].emergencyContactDdi} <span className="required-asterisk">*</span>
              </label>
              <input
                type="number"
                inputMode="numeric" // mostra teclado numérico em celulares
                pattern="[0-9]*" // para ajudar na validação e teclados virtuais
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].emergencyContactDdi}
                value={payload?.emergencyContactDdi ?? ""}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setPayload({ ...payload, emergencyContactDdi: onlyNums });
                }}
              />
            </div>

            <div className="col-span-7 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].emergencyContactPhone}<span className="required-asterisk">*</span>
              </label>
              <input
                type="number"
                inputMode="numeric" // mostra teclado numérico em celulares
                pattern="[0-9]*" // para ajudar na validação e teclados virtuais
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].emergencyContactPhone}
                value={payload?.emergencyContactPhone ?? ""}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setPayload({ ...payload, emergencyContactPhone: onlyNums });
                }}
              />
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].emergencyContactEmail} <span className="required-asterisk">*</span>
              </label>
              <input
                type="email"
                className="w-full filter-input-box placeholder:text-gray-100 placeholder:text-13 dark:text-gray-100"
                placeholder={translate[selectdLanguage].emergencyContactEmail}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    emergencyContactEmail: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <b>{cabecalhos[selectdLanguage].documents}</b>
            </div>

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].photoId} <span className="required-asterisk">*</span>
              </label>
              <input
                type="file"
                accept="image/*"
                className="w-full text-gray-700"
                required
                onChange={(e) => {
                  if (e.target.files?.[0]) {
                    setFiles({
                      ...files,
                      photoId: e.target.files[0],
                    });
                  }
                }}
              />
              <p className="text-xs text-gray-500 mt-1">
                Use the camera to take a photo (on compatible devices)
              </p>
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <b>{cabecalhos[selectdLanguage].interview}</b>
            </div>

            <div className="col-span-12 xl:col-span-6 mt-5">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {translate[selectdLanguage].interviewer} <span className="required-asterisk">*</span>
              </label>
              <div className="filter-search-form col-span-12 xl:col-span-6">
                <i className="uil uil-map-marker"></i>
                <select
                  className="form-select w-full bg-gray-800"
                  name="choices-single-location"
                  id="choices-single-location-education"
                  aria-label={translate[selectdLanguage].interviewer}
                  style={{
                    color: "rgb(204, 206, 214)",
                    fontSize: ".828rem",
                  }}
                  value={payload.interviewer ?? ""}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      interviewer: e.target.value,
                    })
                  }
                >
                  <option value=""></option>
                  {employee.map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.fullName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="col-span-12 xl:col-span-12 mt-5">
              <button
                disabled={isLoading}
                className="px-12 py-4 border rounded-lg border-transparent w-full text-white font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                style={{
                  backgroundColor: '#3c32a3',
                  color: '#ffffff'
                }}
                onMouseEnter={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.backgroundColor = '#2f2780';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.backgroundColor = '#3c32a3';
                  }
                }}
                onClick={singup}
              >
                {isLoading ? (
                  <>
                    <svg className="inline animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Loading...
                  </>
                ) : (
                  <>
                    <i className="uil uil-search me-1"></i>{" "}
                    {translate[selectdLanguage].button}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SingnUp;
